export default __webpack_public_path__ + "static/study-banner992-e9b174b629b1ac609723057832791672.jpg";